import React, {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  InputDateWrapper,
  InputTextWrapper,
  InputNumberWrapper,
  SelectWrapper,
} from '../../../../../../components/UI/Form/Input'
import {PersonModel} from '../../../../model'
import {getPersonById} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {initValues} from '../../../../util/values/person'
import {useTableMaster} from '../../../../hooks'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_PERSON} from '../../../../util/Constants'

const Person: FC = () => {
  const {setError, setValue, watch} = useFormContext()
  const {currentTabItem} = useCentral()
  const [maxLength, setMaxLength] = useState(0)

  const {
    docType,
    nationality,
    sex,
    statusUser,
    getDocTypeList,
    getNationalityList,
    getSexList,
    getStatusUserList,
  } = useTableMaster()
  const getEnterpriseByIdValues = async () => {
    const response = await getPersonById(currentTabItem.idToEdit || '')
    const data = response.data.data
    type PersonModelKeys = keyof PersonModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as PersonModelKeys]) {
            if (fieldName === 'fechaNacimiento') {
              let valueDep = data[fieldName as PersonModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as PersonModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as PersonModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as PersonModelKeys] ?? '')
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }
  useEffect(() => {
    getDocTypeList()
    getSexList()
    getStatusUserList()
    getNationalityList()
    setValue('estado', 'ACT')
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEnterpriseByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleGetMaxLength = (val: any) => {
    const value = val ? val : ''
    setMaxLength(value.length)
    setValue('numeroDocumento', '')
    setError('numeroDocumento', {})
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  let typeName =
    watch('tipoDocumento') === '00' || watch('tipoDocumento') === '07' ? 'alphaNumeric' : 'numeric'

  return (
    <ContentForm isEdit={false} title={TITLE_FORM_PERSON}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Doc. Id.'
            name='tipoDocumento'
            data={docType}
            onChangeValue={handleGetMaxLength}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Número de Doc. Id.'
            name='numeroDocumento'
            textPlaceholder='Escribe el nro de documento'
            maxLength={maxLength}
            disabled={isDisabled}
            type={typeName}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Nombres'
            name='nombres'
            textPlaceholder='Escribe el nombre'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Apellido Paterno'
            name='apellidoPaterno'
            textPlaceholder='Escribe el apellido paterno'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Apellido Materno'
            name='apellidoMaterno'
            textPlaceholder='Escribe el apellido materno'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Sexo' name='sexoId' data={sex} required />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Teléfono'
            name='telefono'
            textPlaceholder='Escribe el teléfono'
            type='telephone'
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Teléfono 2'
            name='telefono2'
            textPlaceholder='Escribe el teléfono'
            type='telephone'
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Correo'
            name='email'
            textPlaceholder='Escribe el correo'
            type='any'
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputDateWrapper
            labelText='Fecha de nacimiento'
            name='fechaNacimiento'
            minValue={'1900-01-01'}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Estado' name='estado' data={statusUser} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Nacionalidad' name='nacionalidadId' data={nationality} />
        </div>
      </div>
      {/* <pre>{JSON.stringify(watch(), null ,2)}</pre> */}
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Person
